export function generateColorFromId(id) {
  const hash = String(id)
    .split('')
    .reduce((acc, char) => char.charCodeAt(0) + ((acc << 5) - acc), 0);
  const hue = Math.abs(hash % 360);
  return `hsl(${hue}, 70%, 85%)`;
}

export function resolveDiagramTemplate(deviceRecord) {
  if (!deviceRecord) return 'generic';
  const fromType = deviceRecord.model?.equipmenttype?.diagram_template;
  if (fromType && fromType !== 'generic') {
    return fromType;
  }
  const uCount = deviceRecord.number_of_u || 1;
  if (uCount === 1) return 'server-1u';
  if (uCount === 2) return 'server-2u';
  return 'generic';
}

export function getDiagramConfig(deviceRecord) {
  const model = deviceRecord?.model || {};
  return {
    portCount: model.port_count != null ? model.port_count : 48,
    sfpCount: model.sfp_count != null ? model.sfp_count : 6,
    portRows: model.port_rows || 2,
    sfpRows: model.sfp_rows || 1,
    topRowNumbering: model.top_row_numbering || 'odd',
  };
}

export function getTemplateLabel(template) {
  const labels = {
    'switch-48-sfp': '48-Port Switch + 6 SFP',
    'server-1u': '1U Server',
    'server-2u': '2U Server',
    'patch-panel': 'Patch Panel',
    patchbox: 'Patchbox',
    router: 'Router',
    firewall: 'Firewall',
    ups: 'UPS',
    generic: 'Generic Device',
  };
  return labels[template] || 'Device';
}

export function getTemplateMinHeight(template, config) {
  const heights = {
    'switch-48-sfp': config?.portRows === 2 ? 170 : 130,
    'server-1u': 72,
    'server-2u': 110,
    'patch-panel': 88,
    patchbox: 88,
    generic: 64,
  };
  return heights[template] || 64;
}

export function getPortsForRackDevice(rackDeviceId, ports, deviceRecord) {
  if (!deviceRecord?.deviceregistry) return [];
  const devId =
    typeof deviceRecord.deviceregistry === 'object'
      ? deviceRecord.deviceregistry._id
      : deviceRecord.deviceregistry;
  return (ports || []).filter(
    (p) => String(p.deviceregistry) === String(devId),
  );
}

export function extractPortNumber(interfaceName) {
  if (!interfaceName) return null;
  const match = String(interfaceName).match(/(\d+)\s*$/);
  return match ? parseInt(match[1], 10) : null;
}

export const enhancedTheme = {
  rackBg: '#e8ecf1',
  rackBorder: '#b0bec5',
  deviceBg: '#ffffff',
  deviceBorder: '#1890ff',
  deviceHeaderBg: '#e6f4ff',
  sectionLabel: '#595959',
  portEmpty: '#e0e0e0',
  portRegistered: '#52c41a',
  portConnected: '#1890ff',
  portSelected: '#722ed1',
};
